module.exports = __webpack_public_path__ + "img/turbo_on.addb6480.svg";